export default __webpack_public_path__ + "static/media/spa.bc2a7f3f.png";